<div class="top-section-background">
  <ion-grid [fixed]="true">
    <ion-row>
      <ion-col>
        <div
          *ngIf="
            platformService?.platformType ===
            platformService?.platformEnum?.desktop
          "
        >
          <ion-grid [fixed]="true">
            <ion-row>
              <ion-col>
                <app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>
              </ion-col>
              <ion-col class="right-align-column">
                <ion-button
                  class="btn-download"
                  fill="clear"
                  (click)="showDownloadInsightsModal(true)"
                  data-cy="download-order-button"
                  ><ion-icon name="download-outline"></ion-icon
                  >{{ 'i18n.orderInsightsPage.download' | translate }}
                </ion-button>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>
                <div class="header-section">
                  <h1 data-cy="order-insights-title-text">
                    {{
                      'i18n.orderInsightsPage.orderInsight'
                        | translate
                        | uppercase
                    }}
                  </h1>
                  <ng-container *appShowSplit="[pmeViewToggleFeatureFlag]">
                    <div class="insights-toggle">
                      <ion-button
                        [ngClass]="
                          toggleButtons[ViewType.INSIGHTS].selected
                            ? 'active-view-button'
                            : 'inactive-view-button'
                        "
                        (click)="toggleView(ViewType.INSIGHTS)"
                        data-cy="insights-view-page-button"
                      >
                        <ion-label>
                          {{
                            'i18n.orderInsightsPage.toggleViews.insightsViewLabel'
                              | translate
                          }}
                        </ion-label>
                      </ion-button>
                      <ion-button
                        [ngClass]="
                          toggleButtons[ViewType.PRICING].selected
                            ? 'active-view-button'
                            : 'inactive-view-button'
                        "
                        (click)="toggleView(ViewType.PRICING)"
                        data-cy="order-insights-page-button"
                      >
                        <ion-label>
                          {{
                            'i18n.orderInsightsPage.toggleViews.pricingViewLabel'
                              | translate
                          }}
                        </ion-label>
                      </ion-button>
                    </div>
                  </ng-container>
                </div>
              </ion-col>
            </ion-row>
            <ion-row>
              <div class="cookbook-and-delivery-date-row">
                <div class="delivery-date-and-order-number">
                  <div>
                    <span>{{
                      'i18n.orderInsightsPage.orderNum' | translate
                    }}</span>
                    <span
                      >&nbsp;{{ order?.orderHeader?.tandemOrderNumber }}</span
                    >
                  </div>
                  <div>
                    <span>{{
                      'i18n.orderInsightsPage.delivery' | translate
                    }}</span>
                    <span>
                      &nbsp;{{
                        order?.orderHeader?.confirmedDeliveryDate
                          | date: 'fullDate' : 'GMT'
                      }}
                    </span>
                  </div>
                </div>
                <app-order-percentages-bar
                  [data]="percentagesDisplayed"
                ></app-order-percentages-bar>
              </div>
            </ion-row>
          </ion-grid>
        </div>
        <div
          *ngIf="
            platformService?.platformType ===
            platformService?.platformEnum?.tablet
          "
        >
          <ion-row>
            <ng-container *appShowSplit="[pmeViewToggleFeatureFlag]">
              <ion-col>
                <div class="insights-toggle">
                  <ion-button
                    [ngClass]="
                      toggleButtons[ViewType.INSIGHTS].selected
                        ? 'active-view-button'
                        : 'inactive-view-button'
                    "
                    (click)="toggleView(ViewType.INSIGHTS)"
                    data-cy="insights-view-page-button"
                  >
                    <ion-label>
                      {{
                        'i18n.orderInsightsPage.toggleViews.insightsViewLabel'
                          | translate
                      }}
                    </ion-label>
                  </ion-button>
                  <ion-button
                    [ngClass]="
                      toggleButtons[ViewType.PRICING].selected
                        ? 'active-view-button'
                        : 'inactive-view-button'
                    "
                    (click)="toggleView(ViewType.PRICING)"
                    data-cy="order-insights-page-button"
                  >
                    <ion-label>
                      {{
                        'i18n.orderInsightsPage.toggleViews.pricingViewLabel'
                          | translate
                      }}
                    </ion-label>
                  </ion-button>
                </div>
              </ion-col>
            </ng-container>
            <ion-col>
              <div class="tablet-download-button">
                <ion-button
                  fill="clear"
                  (click)="showDownloadInsightsModal(true)"
                  ><ion-icon name="download-outline"></ion-icon
                  >{{ 'i18n.orderInsightsPage.download' | translate }}
                </ion-button>
              </div>
            </ion-col>
          </ion-row>
          <div class="header-section">
            <ion-row>
              <div class="cookbook-and-delivery-date-row">
                <div class="delivery-date-and-order-number">
                  <div>
                    <span>{{
                      'i18n.orderInsightsPage.orderNum' | translate
                    }}</span>
                    <span
                      >&nbsp;{{ order?.orderHeader?.tandemOrderNumber }}</span
                    >
                  </div>
                  <div>
                    <span>{{
                      'i18n.orderInsightsPage.delivery' | translate
                    }}</span>
                    <span>
                      &nbsp;{{
                        order?.orderHeader?.confirmedDeliveryDate
                          | date: 'fullDate' : 'GMT'
                      }}
                    </span>
                  </div>
                </div>
                <app-order-percentages-bar
                  [data]="percentagesDisplayed"
                ></app-order-percentages-bar>
              </div>
            </ion-row>
          </div>
        </div>
        <div
          *ngIf="
            platformService?.platformType ===
            platformService?.platformEnum?.mobile
          "
        >
          <ng-container *appShowSplit="[pmeViewToggleFeatureFlag]">
            <div class="insights-toggle">
              <ion-button
                [ngClass]="
                  toggleButtons[ViewType.INSIGHTS].selected
                    ? 'active-view-button'
                    : 'inactive-view-button'
                "
                (click)="toggleView(ViewType.INSIGHTS)"
                data-cy="insights-view-page-button"
              >
                <ion-label>
                  {{
                    'i18n.orderInsightsPage.toggleViews.insightsViewLabel'
                      | translate
                  }}
                </ion-label>
              </ion-button>
              <ion-button
                [ngClass]="
                  toggleButtons[ViewType.PRICING].selected
                    ? 'active-view-button'
                    : 'inactive-view-button'
                "
                (click)="toggleView(ViewType.PRICING)"
                data-cy="order-insights-page-button"
              >
                <ion-label>
                  {{
                    'i18n.orderInsightsPage.toggleViews.pricingViewLabel'
                      | translate
                  }}
                </ion-label>
              </ion-button>
            </div>
          </ng-container>
          <div class="mobile-header-and-ellipses">
            <div class="mobile-header-section">
              <div>
                <span>{{ 'i18n.orderInsightsPage.orderNum' | translate }}</span>
                <span>&nbsp;{{ order?.orderHeader?.tandemOrderNumber }}</span>
              </div>

              <div class="delivery-date">
                <span>{{ 'i18n.orderInsightsPage.delivery' | translate }}</span>
                <span>
                  &nbsp;
                  {{
                    order?.orderHeader?.confirmedDeliveryDate
                      | date: 'M/d/yyyy' : 'GMT'
                  }}
                </span>
              </div>
            </div>
            <div>
              <ion-icon
                class="additional-info-ellipsis"
                data-cy="additional-info-ellipsis-icon"
                name="ellipsis-vertical-circle-sharp"
                (click)="openAdditionalOptions($event)"
              ></ion-icon>
            </div>
          </div>
          <app-order-percentages-bar
            [data]="percentagesDisplayed"
          ></app-order-percentages-bar>
        </div>
      </ion-col>
    </ion-row>
    <div class="header-quick-filters" #filterContainer>
      <div
        class="inner-filters single-filter"
        *ngFor="let quickFilter of quickFilters; let i = index"
        data-cy="usf-filtering-banner-quick-filter-button"
        (click)="toggleStatusFilter(quickFilter, i)"
        [ngClass]="quickFilter.selected ? 'selected' : 'inner-filters'"
      >
        <span class="filter-title">{{
          (quickFilter.translationKey | translate) || quickFilter.title
        }}</span>
        <span *ngIf="i > 0">
          <ion-badge class="badge" [ngClass]="quickFilter?.badgeColor">{{
            quickFilter.badgeCount
          }}</ion-badge>
        </span>
      </div>
    </div>
  </ion-grid>
</div>
